import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

export interface SnackbarMessage {
  title: string;
  message: string;
  severity: "success" | "info" | "warning" | "error";
  key: number;
}

function useAlertMultiMessageSnackbar() {
  const [snackPack, setSnackPack] = React.useState<readonly SnackbarMessage[]>([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState<SnackbarMessage | undefined>(undefined);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const addSnackbarMessage = (
    title: string,
    message: string,
    severity: "success" | "info" | "warning" | "error" = "success"
  ) => {
    setSnackPack((prev) => [...prev, { title, message, severity: severity, key: new Date().getTime() }]);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  return {
    addSnackbarMessage: addSnackbarMessage,
    AlertMultiMessageSnackbarComponent: (
      <div>
        <Snackbar
          key={messageInfo ? messageInfo.key : undefined}
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          TransitionProps={{ onExited: handleExited }}
          sx={{ maxWidth: "500px" }}
        >
          <Alert onClose={handleClose} severity={messageInfo?.severity ?? "success"} sx={{ width: "100%" }}>
            {messageInfo && messageInfo.title ? <AlertTitle>{messageInfo.title}</AlertTitle> : undefined}
            {messageInfo && messageInfo.message ? messageInfo.message : undefined}
          </Alert>
        </Snackbar>
      </div>
    ),
  };
}

export default useAlertMultiMessageSnackbar;
